import React, { Component } from "react";

import Menu from "./menu";

import "./css/prevent_default.css";

import talkSlidesPDF from "./files/Prevent Default - The future of authoring tools (FT2017).pdf";

class PreventDefault extends Component {
  render() {
    return (
      <div className="prevent-default-page">
        <Menu type="talks" />
        <div className="section-wrapper conclusion">
          <div className="section context">
            <div className="column">
              <h1>Prevent Default</h1>
              <h2>The future of authoring tools</h2>
              <p>
                <a href="https://www.youtube.com/@FrontTrends/videos" target="_blank" rel="noopener noreferrer">
                  Front-Trends 2017
                </a>{" "}
                Warsaw, Poland
              </p>
              <h3>Abstract</h3>
              <p>
                Today’s devices are built around the web browser and chances are good every document you share will be
                delivered over the web — yet our tools still enforce the limitations of paper.
              </p>
              <p>
                The web acts as a true equalizer crossing physical borders, walled gardens and is the purest expression
                of the digital medium in use today. The truly accessible, portable document format of today is the
                website and to fully realize the potential of this medium we need to rethink what general purpose
                (productivity) software for the web can be.
              </p>
              <p>
                In this talk we'll start from the observation that if you strip everything away the web should reduce to
                plain text. Through a series of case studies we'll examine the historical challenges and possible future
                of text editing on the web.
              </p>
            </div>
            <div className="column">
              <div className="talk-video">
                <figure className="youtube">
                  <iframe
                    width="560"
                    height="315"
                    title="Prevent Default - The future of authoring tools"
                    src="https://www.youtube.com/embed/JCAjBXQJE0A?rel=0&amp;showinfo=0"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </figure>
              </div>
              <p>
                <a
                  className={"talk-slides-link"}
                  title="Prevent Default - The future of authoring tools"
                  href={talkSlidesPDF}
                >
                  Download slides
                </a>
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PreventDefault;



// WEBPACK FOOTER //
// ./src/prevent_default.js